class Logger {
	static Info(...args: any) {
		console.log(...this.Now(), ...args);
	}

	static Debug(...args: any) {
		console.debug(...this.Now(), ...args);
	}

	static Error(...args: any) {
		console.error(...this.Now(), ...args);
	}

	static ApiDummy(
		method: string,
		url: string,
		headers: any,
		body: any,
		data: any,
		...args: any
	) {
		console.debug(
			...this.Now(),
			`API Dummy ${method.toUpperCase()} ${url}`,
			"\nHeaders:  ",
			headers ? headers : null,
			"\nSend Body:",
			body ? body : null,
			"\nGet Body: ",
			data ? data : null,
			...args
		);
	}

	static ApiError(
		method: string,
		url: string,
		headers: any,
		body: any,
		data: any,
		...args: any
	) {
		console.error(
			...this.Now(),
			`API Error ${method.toUpperCase()} ${url}`,
			"\nHeaders:  ",
			headers ? headers : null,
			"\nSend Body:",
			body ? body : null,
			"\nGet Body: ",
			data ? data : null,
			"\nReponse:  ",
			...args
		);
	}

	static Page(nome: string) {
		console.log(...this.Now(), "Caricamento pagina: ", nome);
	}

	static Now() {
		const now = new Date();

		const h =
			now.getUTCHours() < 10
				? `0${now.getUTCHours()}`
				: `${now.getUTCHours()}`;

		const m =
			now.getUTCMinutes() < 10
				? `0${now.getUTCMinutes()}`
				: `${now.getUTCMinutes()}`;

		const s =
			now.getUTCSeconds() < 10
				? `0${now.getUTCSeconds()}`
				: `${now.getUTCSeconds()}`;

		const ms =
			now.getMilliseconds() < 100
				? `0${now.getMilliseconds()}`
				: `${now.getMilliseconds()}`;

		const time = `${h}:${m}:${s}.${ms}`;

		return [
			"%c" + time,
			"font-size: xx-small; color:#0E4171; background-color: #E8E8E8; border-radius: 2px; padding-left: 2px; padding-right: 2px; font-family: 'League Gothic';",
		];
	}
}

export default Logger;
